var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosesmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00137 5.9849L1.78471 9.20156C1.65137 9.3349 1.49026 9.39879 1.30138 9.39323C1.11249 9.38767 0.951375 9.31823 0.818042 9.1849C0.684708 9.05156 0.618042 8.88767 0.618042 8.69323C0.618042 8.49879 0.684708 8.3349 0.818042 8.20156L4.01804 5.00156L0.801375 1.7849C0.668042 1.65156 0.604153 1.48767 0.609708 1.29323C0.615264 1.09878 0.684708 0.934896 0.818042 0.801563C0.951375 0.668229 1.11526 0.601562 1.30971 0.601562C1.50415 0.601562 1.66804 0.668229 1.80138 0.801563L5.00137 4.01823L8.21804 0.801563C8.35138 0.668229 8.51526 0.601562 8.70971 0.601562C8.90415 0.601562 9.06804 0.668229 9.20138 0.801563C9.33471 0.934896 9.40138 1.09878 9.40138 1.29323C9.40138 1.48767 9.33471 1.65156 9.20138 1.7849L5.98471 5.00156L9.20138 8.21823C9.33471 8.35156 9.40138 8.51267 9.40138 8.70156C9.40138 8.89045 9.33471 9.05156 9.20138 9.1849C9.06804 9.31823 8.90415 9.3849 8.70971 9.3849C8.51526 9.3849 8.35138 9.31823 8.21804 9.1849L5.00137 5.9849Z",
    fill: "#000103"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosesmall);
export default __webpack_public_path__ + "static/media/closesmall.bbc531de3a2312308af960d9daf28773.svg";
export { ForwardRef as ReactComponent };